//Custom states
export const registerStates = (states) => {

    states.customState = (state = {}, action) => {
        switch (action.type) {
            case 'SCROLLED':
                return {
                    ...state,
                    scrolled: action.scrolled
                };
            default:
                return state;
        }
    };

    return states;
}